export const SolutionsContent = {
  section1: {
    title: "Przeglądy instalacji elektrycznych, gazowych i systemów alarmowych",
    paragraphs: [
      `Przeglądy realizowane przez firmy z naszej platformy pomagają wcześnie wykryć potencjalne zagrożenia i wskazują konkretne działania naprawcze. Weryfikują stan instalacji zgodnie z obowiązującymi przepisami oraz dobrymi praktykami branżowymi.`,
      `Certyfikowani specjaliści działają sprawnie, aby ograniczyć wpływ przeglądów na codzienne funkcjonowanie budynku. Znajdziesz ich na terenie całej Polski – obsługują zarówno lokale mieszkalne, jak i obiekty komercyjne.`,
      `Zadbaj o bezpieczeństwo użytkowników i uniknij problemów prawnych wynikających z zaniedbań. Porównaj dostępne oferty i znajdź odpowiedniego specjalistę w swoim mieście.`,
    ],
  },
  seo: {
    title: "Rozwiązania",
    description:
      "Platforma przeznaczona dla właścicieli nieruchomości, zarządców budynków, agentów nieruchomości i właścicieli domów. Porównaj oferty certyfikowanych firm i znajdź specjalistę dopasowanego do Twoich potrzeb.",
  },
};
